<template>
    <div class="card-wrap">
      <div style="float:left; height: 100%">
      <div class="logo">
        <img src="../assets/logo.png" alt="logo" id="logo"/>
        <span>鹏聚商城商户管理平台</span>
      </div>
      </div>
      <el-dropdown class="realName" @command="handleCommand">
        <span class="el-dropdown-link">
          <el-icon><user /></el-icon>
          {{authStore.user.nickName}}
          <el-icon class="el-icon--right">
            <arrow-down />
          </el-icon>
        </span>
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item command="modifyPwd">修改密码</el-dropdown-item>
            <el-dropdown-item command="logout">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </div>
    <el-dialog title="修改密码" v-model="dialogVisible" width="400px">
      <el-form :model="modifyPwdForm" label-width="80px">
        <el-form-item label="原密码" prop="oldPassword">
          <el-input v-model="modifyPwdForm.oldPwd" type="password"></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="newPassword">
          <el-input v-model="modifyPwdForm.newPwd" type="password"></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="confirmPassword">
          <el-input v-model="modifyPwdForm.rePwd" type="password"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitForm">确定</el-button>
      </div>
    </el-dialog>
</template>

<script>
import { ref } from "vue";
import { useAuthStore } from "@/store/auth";
import api from "@/api/request";
import {ElMessage} from "element-plus";
// import User from "@/views/system/User";
export default {
  // components: {User},
  setup() {
    const authStore = useAuthStore();

    const handleCommand = (command) => {
      if (command === "modifyPwd") {
        modifyPwdForm.value = {
          oldPwd: "",
          newPwd: "",
          rePwd: ""
        }
        dialogVisible.value = true
      } else if (command === "logout") {
        authStore.clearToken()
        location.href = "/login"
      }
    }

    const modifyPwdForm = ref({
      oldPwd: "",
      newPwd: "",
      rePwd: ""
    })

    const dialogVisible = ref(false)

    const submitForm = async () => {
      if (modifyPwdForm.value.newPwd !== modifyPwdForm.value.rePwd) {
        ElMessage.error("两次输入的密码不一致")
        return
      }
      try {
        await api.post("/user-center-server/sys_user/set/pwd", modifyPwdForm.value)
        dialogVisible.value = false
        ElMessage.success("密码修改成功，请重新登录，3秒后自动跳转到登录页面")
        setTimeout(() => {
          location.href = "/login"
        }, 3000);
      } catch (error){}
    }

    return {authStore, handleCommand, modifyPwdForm, dialogVisible, submitForm}
  }
}
</script>

<style lang="scss" scoped>
.logo {
  display: flex;
  align-items: center; /* 垂直居中 */
  height: 100%;
  padding-left:  30px;
  color: #f2af46;
  font-weight: bold;
}

.logo #logo {
  width: 40px;
  height: 40px;
  margin-right: 10px; /* 调整图片和文字之间的间距 */
}

.realName{
  padding-right: 20px;
  align-items: center; /* 垂直居中 */
  height: 100%;
  float: right;
  color: #f2af46;
  cursor: pointer;
}

.card-wrap{
  //text-align: right;
  height: 59px;
  width: 100%;
  border-bottom: 1px solid #e6ebf5;
  background-color: #fff;
  overflow: hidden;
  color: #303133;
  -webkit-transition: .3s;
  transition: .3s;
  box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
}

.el-dropdown-link:focus-visible {
  outline: unset;
}
</style>